/*jshint esversion: 6 */

import $ from 'jquery';
import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

let $productImagesPreviewsSlider =  $('.product-images__previews');
let $productImagesPreviewsSliderInner = $('.product-images__previews__items');


function productImagesPreviews() {
  $productImagesPreviewsSliderInner.slick({
    infinite: false,
    adaptiveHeight: true,
    autoplay: false,
    fade: false,
    // nextArrow: '',
    // prevArrow: '',
    pauseOnHover: true,
    dots: false,
    appendArrows: $('.product-images__previews'),
    speed: 500,
    slidesToShow: 3
  });
}

export default productImagesPreviews;